export default "__VITE_ASSET__DDkjo8ti__"